// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-modal .top-section {
  display: flex;
  justify-content: space-between;
  height: 36px;
  position: sticky;
  top: 0;
}

.order-modal .top-section h5 {
  font-family: Poppins;
  font-weight: 500;
  font-size: 24;
  line-height: 36px;
}

.order-modal hr {
  width: 100%;
  border-color: #8b8b8b;
  height: 10px;
  margin: 8px 0;
}

.order-modal .orders-list {
  max-height: 512px;
  min-height: 500px;
  overflow-y: auto;
  height: 510px;
}

.order-modal .orders-list::-webkit-scrollbar {
  width: 10px;
  height: 0px;
}
.order-modal .orders-list::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.order-modal .orders-list .day-section {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.order-modal .orders-list .day-section span {
  width: 10px;
  height: 10px;
  background-color: #50c878;
  border-radius: 50%;
  margin-right: 10px;
}

.order-modal .orders-list .day-section strong {
  font-family: Poppins;
  font-weight: 400;
  font-size: 14px;
  color: #8b8b8b;
}
.order-modal .orders-list .notification {
  /* border: 1px solid #ccc; */
  /* margin: 10px 0; */
}
.order-modal .orders-list .notification p {
  font-family: Karla;
  font-weight: 400;
  font-size: 16px;
  line-height: 18.7px;
  padding: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/features/Setting/order/components/ordersModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".order-modal .top-section {\n  display: flex;\n  justify-content: space-between;\n  height: 36px;\n  position: sticky;\n  top: 0;\n}\n\n.order-modal .top-section h5 {\n  font-family: Poppins;\n  font-weight: 500;\n  font-size: 24;\n  line-height: 36px;\n}\n\n.order-modal hr {\n  width: 100%;\n  border-color: #8b8b8b;\n  height: 10px;\n  margin: 8px 0;\n}\n\n.order-modal .orders-list {\n  max-height: 512px;\n  min-height: 500px;\n  overflow-y: auto;\n  height: 510px;\n}\n\n.order-modal .orders-list::-webkit-scrollbar {\n  width: 10px;\n  height: 0px;\n}\n.order-modal .orders-list::-webkit-scrollbar-thumb {\n  background-color: transparent;\n}\n\n.order-modal .orders-list .day-section {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.order-modal .orders-list .day-section span {\n  width: 10px;\n  height: 10px;\n  background-color: #50c878;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.order-modal .orders-list .day-section strong {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 14px;\n  color: #8b8b8b;\n}\n.order-modal .orders-list .notification {\n  /* border: 1px solid #ccc; */\n  /* margin: 10px 0; */\n}\n.order-modal .orders-list .notification p {\n  font-family: Karla;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 18.7px;\n  padding: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
